module.exports = __webpack_public_path__ + "static/media/puzzle2.3d742e3e.png";